<template>
	<div class="assessItem" @click="goDetail(item)">
        <div class="image bg-cover" :style="{'background-image':'url('+item.image+')'}">
			<div class="play-wrap flex-center">
				<img src="~@assets/img/play-white.png">
			</div>
		</div>
		<p class="title font-20 line-ellipsis">{{item.title}}</p>
		<p>{{item.time}}</p>
    </div>
</template>

<script>
	import Vue from 'vue'
	export default {
		data() {
			return {
			}
		},
		props:['item'],
		methods: {
			goDetail(item){
				this.$router.push('/assessDetail?id='+item.id)
			}
		}
	}
</script>

<style lang="scss">
	.assessItem{
		// display: inline-block;
		// width: 590px;
		// margin-right:20px;
		cursor: pointer;
		color: #ffffff;
		.image{
			position: relative;
			padding-bottom: 56.27%;
			&::after{
				content: '';
				position: absolute;
				background: #3ED8C4;
				height: 3px;
				left: 0;
				bottom: 0;
				width: 100%;
				opacity: 0.5;
				transition: transform .3s,opacity 0.6s;;
				transform: scaleX(0);
				transform-origin: 100% 0;
			}
			.play-wrap{
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				opacity: 0;
				background: rgba($color: #000000, $alpha: 0.5);
				transition:opacity 0.3s;
				img{
					width: 70px;
				}
			}
		}
		&:hover{
			.image::after{
				opacity: 1;
				transform: scaleX(1);
				transform-origin: 0 0;
			}
			.play-wrap{
				opacity: 1;
			}
		}	
		.title{
			line-height: 1.4;
			margin-top: 26px;
			margin-bottom: 6px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/assessItem.vue